module.exports = __webpack_public_path__ + "img/maximet-pro.d494e642.jpg";